import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';

import {
    Validators,
    ReactiveValidationModule,
} from 'angular-reactive-validation';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        DynamicDialogModule,
        ReactiveFormsModule,
        ReactiveValidationModule,
    ],
    selector: 'qwyk-create-custom-view-modal',
    templateUrl: './create-custom-view-modal.component.html',
    styleUrls: ['./create-custom-view-modal.component.scss'],
})
export class CreateCustomViewModalComponent implements OnInit {

    private readonly modal = inject(DynamicDialogRef);

    public dismissAction = 'common.cancel';
    public confirmAction = 'common.save';
    public confirmStyle = 'btn-primary';
    public dismissStyle = null;
    public inputValue = null;
    public form!: FormGroup;

    ngOnInit() {
        this.form = new FormGroup({
            name: new FormControl('', [
                Validators.required(),
                Validators.pattern(/^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$/),
            ]),
        });
    }

    public confirm() {
        const { name } = this.form.value;
        this.modal.close(name);
    }

    public dismiss() {
        this.modal.close();
    }
}
